module.exports = __webpack_public_path__ + "img/front_150.642e5de4.webp";